// src/pages/CalciumCarbonatePage.js
import {
  Box,
  Heading,
  Text,
  Image,
  Container,
  SimpleGrid,
  Stack,
  Button,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";

// ✅ Import the product image
import CalciumCarbonate from "../../img/products/natural-spa-cosmetics-rustic-wooden-table.jpg";
import CalciumCarbonate2 from "../../img/products/Calcium-Carbonate-Masterbatch2.png";

export default function CalciumCarbonatePage() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const colors = {
    teal: "#1da179",
    tealLight: "#34c49b",
  };

  // Motion wrappers
  const MotionHeading = motion(Heading);
  const MotionButton = motion(Button);
  const MotionImage = motion(Image);
  const MotionText = motion(Text);

  return (
    <Box
      bg="gray.50"
      py={16}
      px={4}
      minH="100vh"
      dir={isArabic ? "rtl" : "ltr"}
    >
      <Container maxW="6xl">
        {/* Title */}
        <MotionHeading
          mb={10}
          textAlign="center"
          size="2xl"
          fontWeight="bold"
          color="teal.600"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {isArabic ? "كربونات الكالسيوم" : "Calcium Carbonate"}
        </MotionHeading>

        {/* Request Quote Button */}
        <Flex justify="center" mb={12}>
          <MotionButton
            as={RouterLink}
            to="/request-quotes"
            size="lg"
            borderRadius="full"
            px={8}
            fontWeight="semibold"
            bgGradient={`linear(to-r, ${colors.teal}, ${colors.tealLight})`}
            color="white"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.3 }}
          >
            {isArabic ? "طلب عرض سعر" : "Request a Quote"}
          </MotionButton>
        </Flex>

        {/* Sections */}
        <Stack spacing={16}>
          {/* Intro */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} align="center">
            <MotionImage
              src={CalciumCarbonate}
              alt="Calcium Carbonate"
              borderRadius="xl"
              boxShadow="lg"
              objectFit="cover"
              w="100%"
              h="300px"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            />
                        <MotionImage
              src={CalciumCarbonate2}
              alt="Calcium Carbonate"
              borderRadius="xl"
              boxShadow="lg"
              objectFit="cover"
              w="100%"
              h="300px"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            />
         
          </SimpleGrid>
   <MotionText
              fontSize="lg"
              color="gray.600"
              dangerouslySetInnerHTML={{
                __html: isArabic
                  ? `<p>تقوم آكتيف بوليمرز بإنتاج حشوات كربونات الكالسيوم على أساس أنواع متعددة من البوليمرات لتلبية جميع أنواع التطبيقات، من البثق إلى التشكيل بالحقن. يُستخدم أفضل أنواع كربونات الكالسيوم لضمان أعلى جودة للحشو.</p><br />
                  <p>يتم تصنيع هذه الحشوات بإضافة مجموعة من المضافات والمواد المزلقة التي تسهّل عملية التصنيع وتحسّن الخصائص الميكانيكية للمنتج النهائي. استخدام أفضل أنواع كربونات الكالسيوم يضمن عدم حدوث اصفرار، مما يجعل الحشوات ذات لون أبيض حليبي.</p><br />
                  <p>كما يتم إنتاج درجات مختلفة لكل نوع من الحشوات بحسب التطبيقات المطلوبة.</p><br />
                   <p>تضمن هذه الحشوات تخفيض التكاليف بشكل مناسب دون المساس بجودة المنتج النهائي.</p><br />
                  `
                  : `<p>Active Polymers manufacturers Calcium Carbonate Fillers in multiple polymer bases for all sorts of applications from Extrusion to Molding. Best of calcium carbonate is used to ensure optimum quality of the filler.</p><br />
       
                  <p>These fillers are made by further adding several additives and lubricants which assists in easy processing and enhancing the mechanical properties of the end product. The Best of Calcium used ensures no yellowness further making the fillers milky white in color.</p><br />
      
                   <p>There are further various grades manufactured in each filler as per the applications. These fillers ensures adequate cost cutting without compromising with the quality of the end product.</p>
                  `,
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            />

        </Stack>
      </Container>
    </Box>
  );
}
